import Script from 'next/script';
import { useMemo } from 'react';

import type { EnhancedSectionType } from '@/components/Section/Section';
import type { Seo } from '@/contentful/contentful-exports';
import { parseSolarByStatePath } from '@/utils/parseSolarByStatePath';

import { buildLocalBusinessSchema } from './buildLocalBusinessSchema';
import { buildServiceSchema } from './buildServiceSchema';

interface Props {
  path: string;
  seoFields?: Seo;
  sections: EnhancedSectionType[];
}

export default function GeoSchema({ path, seoFields, sections }: Props) {
  const schema = useMemo(() => {
    const metaTitle = seoFields?.fields?.metaTitle;
    const parsed = parseSolarByStatePath(path, metaTitle);

    if (!parsed || parsed.pageType === 'other') {
      return null;
    }

    if (parsed.pageType === 'branch') {
      return buildLocalBusinessSchema({ path, seoFields, sections });
    }

    return buildServiceSchema({ path, seoFields, parsed });
  }, [path, seoFields, sections]);

  if (!schema) return null;

  return (
    <Script type='application/ld+json' strategy='beforeInteractive'>
      {JSON.stringify(schema)}
    </Script>
  );
}
